import { logger } from '../../util/logger';

// Call the cc-user-facing-service serverless directly (same-origin), mirroring
// answerGeneration.ts and kb-client-nextjs's article-follow-client. The serverless
// derives the user from the request identity and normalizes the locale for kb-server.

export const isFollowingArticle = async (articleId: string, locale: string): Promise<boolean> => {
  try {
    const query = `articleId=${encodeURIComponent(articleId)}&locale=${encodeURIComponent(locale)}`;
    const endpoint = `/_serverless/cc-user-facing-service/article/is-following?${query}`;

    const response = await fetch(endpoint, {
      headers: {
        'Content-Type': 'application/json',
        'x-wix-client-artifact-id': 'wix-chatbot-client',
      },
    });
    if (!response.ok) {
      return false;
    }
    const data = (await response.json()) as { isFollowing?: boolean };
    return Boolean(data?.isFollowing);
  } catch (error) {
    logger.error({
      message: `[articleFollow] Failed to get follow status for the article: ${articleId}`,
      error,
    });
    return false;
  }
};

export const followArticle = async (articleId: string, locale: string): Promise<void> => {
  try {
    const endpoint = '/_serverless/cc-user-facing-service/article/follow';

    await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-wix-client-artifact-id': 'wix-chatbot-client',
      },
      body: JSON.stringify({ articleId, locale }),
    });
  } catch (error) {
    logger.error({
      message: `[articleFollow] Failed to follow the article: ${articleId}`,
      error,
    });
  }
};

export const unfollowArticle = async (articleId: string, locale: string): Promise<void> => {
  try {
    const endpoint = '/_serverless/cc-user-facing-service/article/unfollow';

    await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-wix-client-artifact-id': 'wix-chatbot-client',
      },
      body: JSON.stringify({ articleId, locale }),
    });
  } catch (error) {
    logger.error({
      message: `[articleFollow] Failed to unfollow the article: ${articleId}`,
      error,
    });
  }
};
